import { render } from "./TransactionPage.vue?vue&type=template&id=084b0097"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__